import { useState } from 'react'
import { AccountBalance } from '@mui/icons-material'
import { cn } from '../../lib/utils'

export const BankAccountItem = ({ bank, isSelected, onSelect, tickIcon, bankLogosUrl }) => {
  const [iconSrc, setIconSrc] = useState(() => {
    const branch = bank.ifscCode?.match(/^[A-Za-z]{4}/)?.[0]?.toLowerCase()
    return branch ? `${bankLogosUrl}/${branch}/symbol.svg` : null
  })
  const ending = bank.accountNo?.slice(-4) || ''
  const label = `${bank.accountHolderName || 'Bank account'}, ${
    bank.bankName || ''
  } account ending in ${ending}`

  return (
    <button
      type='button'
      role='radio'
      aria-checked={isSelected}
      aria-label={label}
      onClick={() => onSelect(bank.accountNo)}
      className={cn(
        'fabits-payment-bank-account w-full min-h-[76px] p-4 flex items-center gap-4 rounded-[16px] text-left cursor-pointer transition-all duration-200 ease-in-out border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
        isSelected
          ? 'fabits-payment-bank-account-selected border-primary-500 bg-primary-50'
          : 'border-transparent hover:bg-[#ecf0f4]',
      )}
    >
      <div className='flex-shrink-0'>
        {iconSrc ? (
          <img src={iconSrc} alt='' onError={() => setIconSrc(null)} height={24} width={24} />
        ) : (
          <AccountBalance className='text-primary-200' />
        )}
      </div>
      <div className='flex flex-col min-w-0'>
        <span className='text-[#2f3c5a] font-semibold truncate'>{bank.accountHolderName}</span>
        <span className='text-[#2f3c5a] text-xs'>
          {bank.bankName} A/c ending in <strong> {ending}</strong>
        </span>
      </div>

      <div className='ml-auto flex-shrink-0' aria-hidden>
        <div className='flex h-6 w-6 items-center justify-center'>
          {isSelected ? (
            <img src={tickIcon} alt='' />
          ) : (
            <span className='box-border block h-5 w-5 shrink-0 rounded-full border-2 border-[#c5cedd] bg-transparent' />
          )}
        </div>
      </div>
    </button>
  )
}

export const PaymentMethodCard = ({
  id,
  selected,
  onSelect,
  icon,
  title,
  supportingText,
  showFastest,
  sparkIcon,
}) => (
  <button
    type='button'
    role='radio'
    aria-checked={selected}
    aria-label={`${title}. ${supportingText}`}
    onClick={() => onSelect(id)}
    className={cn(
      'fabits-payment-option w-full min-h-[80px] border p-4 cursor-pointer rounded-[16px] text-left transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
      selected
        ? 'fabits-payment-option-selected border-primary-500 shadow-[0px_4px_24px_0px_rgba(65,85,141,0.12)] bg-[rgba(255,255,255,1)]'
        : 'border-[rgba(190,190,190,1)]',
    )}
  >
    <div className='flex items-center gap-3 fabits-payment-option-header'>
      <span className='flex h-6 w-6 shrink-0 items-center justify-center [&>img]:h-6 [&>img]:w-6 [&>svg]:h-6 [&>svg]:w-6'>
        {icon}
      </span>
      <div className='flex min-w-0 flex-1 flex-col gap-1'>
        <span
          className={cn(
            'font-dm-sans text-[20px] font-semibold leading-7 tracking-[-0.04em] fabits-payment-option-title',
            selected ? 'text-primary-500' : 'text-black-500',
          )}
        >
          {title}
        </span>
        <span className='font-dm-sans text-[13px] font-medium leading-4 text-black-300 fabits-payment-option-limit inline-flex items-center gap-1 flex-wrap'>
          {showFastest && sparkIcon ? (
            <>
              <img src={sparkIcon} alt='' className='h-3.5 w-3.5' />
              {supportingText}
            </>
          ) : (
            supportingText
          )}
        </span>
      </div>
      <span
        className={cn(
          'ml-auto box-border flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2',
          selected ? 'border-primary-500 bg-primary-500' : 'border-[#c5cedd] bg-transparent',
        )}
        aria-hidden
      >
        {selected ? <span className='block h-2 w-2 rounded-full bg-white' /> : null}
      </span>
    </div>
  </button>
)
